(() => {
  const theme = window.theme || (window.theme = {});
  if (theme.cartState) return;

  let inFlight = null;
  let lastData = null;
  let lastFetchedAt = 0;
  let stale = true;

  const getCartUrl = () => {
    const cartRoute = theme?.routes?.cart || '/cart';
    return `${cartRoute}.js`;
  };

  const fetchCart = async () => {
    const res = await fetch(getCartUrl(), {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    });
    if (!res.ok) throw new Error(res.status);
    return res.json();
  };

  const cartState = {
    get: ({ force = false, ttl = 800 } = {}) => {
      const now = Date.now();
      const hasFreshCache = !stale && lastData && now - lastFetchedAt < ttl;
      if (!force && hasFreshCache) return Promise.resolve(lastData);
      if (!force && inFlight) return inFlight;

      inFlight = fetchCart()
        .then((data) => {
          lastData = data;
          lastFetchedAt = Date.now();
          stale = false;
          inFlight = null;
          return data;
        })
        .catch((err) => {
          inFlight = null;
          throw err;
        });

      return inFlight;
    },
    invalidate: () => {
      stale = true;
    },
    peek: () => lastData
  };

  theme.cartState = cartState;
  window.CartState = cartState;
})();
